import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";

import { CCard, CCardBody, CCol, CRow } from "@coreui/react";

import { usePermissionCheck } from "src/1/common/components/others";
import { Magnifying } from "src/common/assets/icons";
import { CButton, CInput } from "src/common/components/controls";
import { ENTITY_GROUP_CODE, PERMISSION_VALUE } from "src/configs/constant";
import { useMobileDevice } from "src/utils/hooks/viewport";

import { CActionGroup } from "_components/others";

export const ComboItemToolbar = ({
  params,
  onAdd,
  onEdit,
  onRemove,
  canEdit,
  canRemove,
  onSearch,
}) => {
  //#region Data
  const { control, handleSubmit } = useForm({
    defaultValues: params,
  });

  const checkPermission = usePermissionCheck();

  const isMobile = useMobileDevice();
  //#endregion

  //#region Event
  const onClick = (key) => {
    switch (key) {
      case "add":
        return onAdd();
      case "edit":
        return onEdit();
      case "remove":
        return onRemove();
      default:
        return onAdd();
    }
  };

  const search = handleSubmit((searchValues) => onSearch(searchValues));
  //#endregion

  //#region Render
  return (
    <CCard className={classNames("toolbar", !isMobile && "sticky")}>
      <CCardBody>
        <CRow>
          <CCol xs="12" className="action">
            <div>
              <CActionGroup
                onClick={onClick}
                canAdd={checkPermission({
                  [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.CREATE,
                })}
                canEdit={
                  canEdit &&
                  checkPermission({
                    [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.UPDATE,
                  })
                }
                canRemove={
                  canRemove &&
                  checkPermission({
                    [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.DELETE,
                  })
                }
              />
            </div>
          </CCol>
        </CRow>
        <div className="mt-3 flex items-end justify-between">
          <div className="flex items-center gap-3">
            <Controller
              control={control}
              name="code"
              render={({ field }) => (
                <CInput {...field} label="Mã" placeholder="Tìm kiếm theo mã" />
              )}
            />
            <Controller
              control={control}
              name="name"
              render={({ field }) => (
                <CInput
                  {...field}
                  label="Tên"
                  placeholder="Tìm kiếm theo tên"
                />
              )}
            />
          </div>

          <CButton icon={<Magnifying />} onClick={search} className="mr-0">
            Tìm kiếm
          </CButton>
        </div>
      </CCardBody>
    </CCard>
  );
  //#endregion
};
